
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.202 2.654c2.752 2.111 5.712 6.393 6.798 8.69 1.087-2.297 4.046-6.579 6.798-8.69C20.783 1.13 24-.048 24 3.703c0 .749-.42 6.293-.667 7.193-.856 3.13-3.978 3.927-6.755 3.444 4.854.845 6.089 3.642 3.422 6.439-5.064 5.312-7.279-1.333-7.847-3.036-.104-.312-.152-.458-.153-.334 0-.124-.05.022-.153.334-.568 1.703-2.782 8.348-7.847 3.036-2.667-2.797-1.432-5.594 3.422-6.439-2.777.483-5.899-.315-6.755-3.444C.42 9.996 0 4.452 0 3.703 0-.048 3.217 1.13 5.202 2.654z","fill":"#fff"}})])
          )
        }
      }
    